export default "__VITE_ASSET__CIiyocBw__"